import styled from 'styled-components';

export const SuccessPaymentModalContainer = styled.div`
  display: flex;
  flex-direction: column;

  text-align: left;
  height: 100%;

  & .success-icon {
    margin-bottom: 25px;
  }

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 10px;
  }

  h4 {
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #1d201f;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #1d201f;
    margin-bottom: 30px;
  }

  & .subscribe-btn {
    margin-bottom: 30px;
  }
`;
